import React from 'react';
import { Space } from 'antd';
import { Button, TableProps } from 'antd';
import TableComponent from '@/components/table';
import { IImportData } from '@/interfaces/import';
import { downloadExcelTemplate } from '@/utils/templateUtils';
import { ImportOutlined, DownloadOutlined } from '@ant-design/icons';

interface IProps {
  loading: boolean;
  importData: IImportData[];
  onImport: (data: IImportData) => void;
}

const ImportDataTable = ({ loading, importData, onImport }: IProps) => {
  const columns: TableProps<IImportData>['columns'] = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      width: 40,
      align: 'center',
      className: 'text-center',
      render: (_, rec, i) => <Space>{i + 1}</Space>,
    },
    {
      title: 'Module Name',
      dataIndex: 'moduleName',
      key: 'moduleName',
      className: 'font-bold text-blue-700',
    },
    {
      title: '',
      dataIndex: 'templateFileName',
      key: 'templateFileName',
      width: 120,
      render: _ => (
        <Button
          size="small"
          type="default"
          onClick={() => downloadExcelTemplate(_)}
        >
          <DownloadOutlined />
          ดาวน์โหลด
        </Button>
      ),
    },
    {
      title: '',
      dataIndex: 'templateFileName',
      key: 'templateFileName',
      width: 120,
      render: (_, rec) => (
        <Button size="small" type="primary" onClick={() => onImport(rec)}>
          <ImportOutlined />
          นำเข้าข้อมูล
        </Button>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-3">
      <TableComponent<IImportData>
        columns={columns}
        data={{ data: importData, totalRecords: 0 }}
        loading={loading}
        showPagination={false}
        scroll={false}
      />
    </div>
  );
};

export default ImportDataTable;
